<template>
    <section  v-if="hasPermissions(['Options-Groups Read', 'Options-Groups Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                Work is classified into four groups. Group 1 is Daily Cleaning tasks (usually done by an Associate using a cleaning cart). Group 2 are areas like Corridors, Elevators, and Stairwells (usually done by an Associate using auto scrubbers, etc.)  Group 3 is Project Work (floor finishing, carpet shampooing, etc.) Group 4 is non-cleaning tasks. (Waste removal, moves, and setups, outside grounds work, etc.) You can modify the description, but the work the Group represents will always be the same.
            </p>
        </div>

        <div class="tab-content mt-4" v-if="groups.length && hasPermissions(['Options-Groups Read'])">
            <div class="tab-pane fade active show" id="listation">
                    <div class="col-md-8">
                        <form  @submit.prevent="formSubmitLocal()" class="row" v-if="groups.length">
                            <div v-for="(group, i) in groups" :key="i" class="p-0 formdynamic__item col-md-6" style="margin-top:20px; right: unset" >
                                <div  class="formdynamic__item__field">
                                    <label v-html="` Group ${(i + 1)} <b style='color:red;'>*</b>`" class="modal-label mb-1" :for="`assignment`"/>
                                    <input 
                                        style="width: 95%"
                                        type="text" 
                                        maxlength="120" 
                                        v-model="group.name"  
                                        required       
                                    />
                                </div>

                            </div>
                            <div class="col-md-11">
                                <div class="text-center text-md-right text-lg-right">
                                    <CentralLiteButtons @Cancelation="cancel($event)"/>
                                </div>
                            </div>
                        </form>
                        
                    </div>
                </div>
            </div>

        <WaitingModal/>
    </section>

    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import Breadcrumb            from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
import CentralLiteButtons  from '@/components/CentralLiteButtons'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import eventBus from '@/plugins/eventBus'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }        from    'notyf'
import 'notyf/notyf.min.css'; // for React and Vue\

const notyf = new Notyf({
    duration: 8000,
})

export default {

    name: 'Groups',

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
        CentralLiteButtons
    },

    data()
    {
        return {
            notyf,
            user:               this.get_user(),
            title_page:         'Groups',
            rest_api:           `group_facility_name`,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            add_btn:            'Add Group',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       '',
            single_object:      {},
            groups:             [],
            groups_backup:      {},
            array_options:      {},
            select_ids:         [],
        }
    },

    methods: 
    {

        fill_data(data)
        {
            this.groups = data.groups
            this.groups_backup = JSON.parse(JSON.stringify(this.groups))
        },

        formSubmitLocal()
        {
            this.form_data = this.groups
            this.form_submit();
        },

        unshiftObject()
        {
            this.groups_backup = JSON.parse(JSON.stringify(this.groups))
        },

        cancel()
        {
            this.groups = JSON.parse(JSON.stringify(this.groups_backup))
        }
    },

    async mounted()
    {
        if(this.hasPermissions(['Options-Groups Read']))
        {
            await this.api_request('groups')

            eventBus.$on('unshiftObject', () => {
                this.unshiftObject()
            })
        }
    },

    beforeUnmount () 
    {
        this.emitter.off('unshiftObject')
    },

    computed:
    {
        selected()
        {
            const bool = this.groups.filter(item => item.checked)
            return Boolean(bool.length)
        }
    },
}
</script>